import React from 'react';
import { GreenSwitch, RedSwitch } from './Inputs/Switch';

export default function XpressSwitch({ value, onClick, disabled }) {
  const SwitchToUse = value ? GreenSwitch : RedSwitch;
  return <SwitchToUse disabled={disabled} checked={value} onChange={onClick} />;
}
